import { MenuList, Typography, Box } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useTranslation } from 'react-i18next';
import { Language } from '@/types';
import { StyledMenuPaper, StyledMenuItem } from './LanguageMenu.styles';

type LanguageMenuProps = {
  onLanguageChange?: () => void; // Callback to notify parent when language changes
};

export default function LanguageMenu({ onLanguageChange }: LanguageMenuProps) {
  const { i18n } = useTranslation();

  const options = ['English', 'Nederlands'];

  const getCurrentLanguage = (): string => {
    return i18n.language === Language.EN ? 'English' : 'Nederlands';
  };

  const handleLanguageChange = (language: string): void => {
    const langCode = language === 'English' ? Language.EN : Language.NL;

    i18n.changeLanguage(langCode);

    onLanguageChange?.(); // Notify parent component
  };
  return (
    <StyledMenuPaper role='menu'>
      <MenuList disablePadding sx={{ p: 0 }}>
        {options.map((opt) => {
          const selected = opt === getCurrentLanguage();
          return (
            <StyledMenuItem key={opt} selected={selected} onClick={() => handleLanguageChange(opt)}>
              <Typography
                variant='body2'
                color='text.primary'
                sx={{ fontWeight: selected ? 600 : 500 }}
              >
                {opt}
              </Typography>

              {selected && (
                <Box sx={{ ml: 'auto', display: 'flex' }}>
                  <CheckRoundedIcon
                    sx={(theme) => ({
                      color: theme.palette.brand.primary,
                      width: 24,
                      height: 24,
                    })}
                  />
                </Box>
              )}
            </StyledMenuItem>
          );
        })}
      </MenuList>
    </StyledMenuPaper>
  );
}
